"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CombinedTokenStorage = void 0;
var _CombinedSessionItem = require("./CombinedSessionItem");
var _SessionTokenStorage = require("./SessionTokenStorage");
/**
 * TODO: Deprecate or think of a way to differentiate between requested tokens - application may want to get user token,
 * but upon returning null it should try to get a new token instead of returning user token right away
 */
class CombinedTokenStorage extends _SessionTokenStorage.SessionTokenStorage {
  createStorageItem() {
    return new _CombinedSessionItem.CombinedSessionItem();
  }
}
exports.CombinedTokenStorage = CombinedTokenStorage;
